import React, { useState } from 'react';
import loadable from '@loadable/component';

import VerifyConfig from './components/verify-config';
import SeoUpdate from './components/verify-config/seo-update';
import { formatMetricValue } from '../metrics/metrics-helpers';
import ThemeCSSLoader from './components/theme-css-loader';
import { WithTheme } from '../hooks/useTemplateTheme';
import { Helpers } from '../core/src/helpers';
import useTestFlags from '../abtest/useTestFlags';

import './components/configure.less';

const AllConfigurations = loadable(() => Helpers.retryFunc(() => import('./components/all-configurations')));
const CompareConfig = loadable(() => Helpers.retryFunc(() => import('../compare/components/compare-page')));
const CTO = loadable(() => Helpers.retryFunc(() => import('./components')));
const CTOV2 = loadable(() => Helpers.retryFunc(() => import('./components-v2')));

const modifyGtmAttributes = (gtmActions, config) => {
    const { configName, actualPrice } = config || {};
    let configPrice;
    if (typeof actualPrice === 'number') {
        configPrice = actualPrice;
    } else if (typeof actualPrice === 'string') {
        configPrice = /^\$/.test(actualPrice) ? Number(actualPrice.replace(/^\$/, '')) : Number(actualPrice);
    }
    return {
        'data-gtm-category': 'addToCart',
        'data-gtm-object': 'mainSKU',
        'data-gtm-configuration': typeof configName === 'string' ? formatMetricValue(configName) : configName,
        'data-gtm-configPrice': configPrice,
        'data-gtm-quantity': 1,
    };
};

const Configure = props => {
    const { cto } = useTestFlags(['cto']);
    const v2 = cto && cto.variant === 'visid';
    const [compareConfig, setCompareConfig] = useState(false);
    const toggleCompare = () => {
        window.scrollTo(0, 0);
        setCompareConfig(!compareConfig);
    };
    const { match } = props;
    const { params } = match;
    const { slugTwo } = params;
    if (slugTwo === 'all-configurations') {
        return <AllConfigurations />;
    }
    if (compareConfig) {
        return <CompareConfig toggleCompare={toggleCompare} list="cto" modifyGtmAttributes={modifyGtmAttributes} />;
    }

    return (
        <WithTheme CSSLoader={ThemeCSSLoader}>
            <div className="configure">
                <SeoUpdate />
                <VerifyConfig />
                {!v2 ? <CTO toggleCompare={toggleCompare} /> : <CTOV2 toggleCompare={toggleCompare} />}
            </div>
        </WithTheme>
    );
};

export default Configure;
